import React, { useState, useEffect } from "react";
import CTE from "../Constants";
import Modal from "../Modal/Modal";
function ChatOptionsModal(props) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [selectInput, setSelectInput] = useState("");
    const [texts, setTexts] = useState({
        title: "Options",
        placeholder: "View options",
        send: "Send",
        cancel: "Cancel",
    });
    const selectOption = function (event) {
        setSelectInput(props.options[event.target.value]);
        if (isMobile) {
            props.interactionCb(CTE.CONTENT_TYPE.OPTIONS, props.options[event.target.value]);
            setIsModalOpen(false);
        }
    };
    const openModal = function () {
        setIsModalOpen(true);
    };
    const sendSelection = function () {
        props.interactionCb(CTE.CONTENT_TYPE.OPTIONS, selectInput);
        setIsModalOpen(false);
    };
    const isBrowserMobile = function () {
        const toMatch = [/Android/i, /webOS/i, /iPhone/i, /iPad/i, /Windows Phone/i];

        return toMatch.some((toMatchItem) => {
            return navigator.userAgent.match(toMatchItem);
        });
    };
    useEffect(() => {
        if (props.language === "SPANISH") {
            setTexts({
                title: "Opciones",
                placeholder: "Ver opciones",
                send: "Enviar",
                cancel: "Cancelar",
            });
        }
        setIsMobile(window.innerWidth <= 760 && isBrowserMobile());
        window.addEventListener("resize", () => {
            setIsMobile(window.innerWidth <= 760 && isBrowserMobile());
        });
        // unmount
        return () => {
            window.removeEventListener("resize");
        };
        // eslint-disable-next-line
    }, []);
    return (
        <div className="chats-options">
            <Modal
                small
                show={isModalOpen}
                acceptCb={() => sendSelection()}
                closeCb={() => setIsModalOpen(false)}
                acceptText={texts.send}
                cancelText={texts.cancel}
                disabled={false}
            >
                <h1 className="modal__title">{texts.title}</h1>
                <select
                    className="opt-input opt-input--select"
                    value={selectInput}
                    onChange={selectOption}
                >
                    {props.options.map((option, index) => (
                        <option key={index} value={index}>
                            {option.buttonText}
                        </option>
                    ))}
                    <option value="" disabled>
                        {texts.placeholder}
                    </option>
                </select>
            </Modal>
            {!isMobile ? (
                props.text && (
                    <span className="chat-balloon__link" onClick={openModal}>
                        {props.text}
                    </span>
                )
            ) : (
                <select
                    className="opt-input opt-input--select"
                    value={selectInput}
                    onChange={selectOption}
                >
                    {props.options.map((option, index) => (
                        <option key={index} value={index}>
                            {option.buttonText}
                        </option>
                    ))}
                    <option value="" disabled>
                        {texts.placeholder}
                    </option>
                </select>
            )}
        </div>
    );
}
export default ChatOptionsModal;
